module.exports = __webpack_public_path__ + "static/media/agriculture.cf6a6be3.png";